import { IStandardConfigurationAssetTeam } from '../../interfaces/istandard-configuration-asset-team';
import { AssetTeam } from '../asset-team';
import { StandardConfiguration } from '../standard-configuration';

export class StandardConfigurationAssetTeamBase {
  StandardConfigurationAssetTeamId: number;
  StandardConfigurationId: number | null;
  AssetTeamId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  StandardConfiguration?: StandardConfiguration;

  constructor(item?: IStandardConfigurationAssetTeam) {
    if (item) {

      this.StandardConfigurationAssetTeamId = item.StandardConfigurationAssetTeamId;
      this.StandardConfigurationId = item.StandardConfigurationId;
      this.AssetTeamId = item.AssetTeamId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.StandardConfiguration = new StandardConfiguration(item.StandardConfiguration);
    }
  }
}